<template>
    <breadCrumbs title="Date Range Picker" main="Form Widgets" title1="Date Range Picker" />
    <div class="container-fluid">
        <div class="card">
          <div class="card-header pb-0">
            <h3>Date Range Picker</h3>
          </div>
          <div class="card-body">
            <div class="row date-range-picker">
              <div class="col-xl-6">
                <h4 class="sub-title">Date Range Picker</h4>
                <p>The Date Range Picker use the current value of the input to initialize, and update the input if new dates are chosen.</p>
                <div class="theme-form">
                  <div>
                    <Datepicker class="datepicker-here form-control digits" v-model="date" range multi-calendars /> 
                  </div>
                </div>
              </div>
              <div class="col-xl-6">
                <h4 class="sub-title">Predefined Ranges</h4>
                <p>This example shows the option to predefine date ranges that the user can choose from a list.</p>
                <div class="theme-form">
                  <div>
                    <Datepicker class="datepicker-here form-control digits" v-model="date1" range />
                  </div>
                </div>
              </div>
              <div class="col-xl-6">
                <h4 class="sub-title">Single Date Picker</h4>
                <p>The Date Range Picker can be turned into a single date picker widget with only one calendar. In this example, dropdowns to select a month and year have also been enabled at the top of the calendar to quickly jump to different months.</p>
                <div class="theme-form">
                  <div>
                    <Datepicker class="datepicker-here form-control digits" v-model="date2" :format="format" placeholder="yyyy-mm-dd" /> 
                  </div>
                </div>
              </div>
              <div class="col-xl-6">
                <h4 class="sub-title">Input Initially Empty</h4>
                <p>If you're using a date range as a filter, you may want to attach a picker to an input but leave it empty by default. This example shows how to accomplish that using the <code>autoUpdateInput</code> setting, and the <code>apply</code> and <code>cancel</code> events.</p>
                <div class="theme-form">
                  <div>
                    <Datepicker class="datepicker-here form-control digits" v-model="date3" range multi-calendars /> 
                  </div>
                </div>
              </div>
              <div class="col-lg-12">
                <h4 class="sub-title">Date and Time</h4>
                <p>The Date Range Picker can also be used to select times. Hour, minute and (optional) second dropdowns are added below the calendars. An option exists to set the increment count of the minutes dropdown to e.g. offer only 15-minute or 30-minute increments.</p>
                <div class="theme-form">
                  <div>
                    <Datepicker class="datepicker-here form-control digits" v-model="date4" range multi-calendars /> 
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
</template>
<script>
import {ref,onMounted} from "vue"
export default{
    setup(){
      const date = ref();
      const date1=ref();
      const date2 = ref();
      const date3 = ref();
      const date4 = ref();
      const format = (date) => {
            const day = date.getDate();
            const month = date.getMonth() + 1;
            const year = date.getFullYear();
            return ` ${day}/${month}/${year}`;
        }
onMounted(() => {
  const startDate = new Date();
  const endDate = new Date(new Date().setDate(startDate.getDate() + 7));
  const startDate1 = new Date();
  const endDate1 = new Date(new Date().setDate(startDate1.getDate() + 7));
  const startDate2 = new Date();
  const endDate2 = new Date(new Date().setDate(startDate2.getDate() + 7));
  const startDate3 = new Date();
  const endDate3 = new Date(new Date().setDate(startDate3.getDate() + 7));
  date.value = [startDate, endDate];
  date1.value = [startDate1, endDate1];
  date3.value = [startDate2, endDate2];
  date4.value = [startDate3, endDate3];
})
return{
  date,
  date1,
  date2,
  format,
  date3,
  date4
}
    }
}
</script>